import { Box, Paper, Grid, Typography } from "@mui/material";

export default function OrganiserDetailsHeader() {

    return <Box sx={{ width: '100%' }} component={Paper}>

        <Grid container rowSpacing={4}>

            <Grid size={{ xs: 12 }}></Grid>

            <Grid size={{ xs: 12 }} sx={{ marginLeft: '2%' }}>
                <Typography variant='subtitle1'>
                    Please review the information below before selecting the organiser type:
                </Typography>
            </Grid>

            <Grid size={{ xs: 12 }} sx={{ marginLeft: '2%', marginRight: '2%' }}>
                <Typography variant='subtitle1'>
                    <b>Lead Organiser:</b>
                </Typography>

                <Typography variant='subtitle1'>
                    <p>
                        Events involving the teaching of technical skills, patient care, or other specific
                        skills must be <b>organised and delivered</b> under the supervision of a named medical
                        practitioner/consultant currently registered on the Specialist Division of the
                        Medical Council Register.
                    </p>

                    <p>
                        Events that provide general clinical education but not involving technical skills must also
                        be <b>supervised</b> by a medical practitioner or consultant registered on the Specialist Division
                        of the Medical Council Register.
                    </p>

                    <p>
                        Events offering broader, non-clinical or general education may be delivered under the
                        supervision of suitably qualified professionals, where deemed appropriate by the
                        Professional Development Committee.
                    </p>
                </Typography>
            </Grid>

        </Grid>
    </Box>
}
